/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { Column } from 'react-table';
import { JsiInterceptorRequest } from '../../interface/Crash';
import {
    RequestJsiInterceptorKind,
    RequestJsiInterceptorKindTag,
    RequestMethod,
    RequestMethodTag,
    RequestStatusTag,
} from '../RequestTags';
import { TableContainer } from '../table/TableContainer';
import { Box } from '@chakra-ui/react';
import { formatTimeHHmmssSSS, toISOString } from '../../helper/formatTime';

export const JsiInterceptorFrameRequestsView: React.FC<{
    requests: Record<string, JsiInterceptorRequest>;
    setSelected: (request: JsiInterceptorRequest) => void;
}> = React.memo(({ requests, setSelected }) => {
    if (!requests) return null;
    const requestsArray = React.useMemo(
        () =>
            Object.entries(requests)
                .filter((r) => r[0] !== '__class__' && r[0] !== '__id__')
                .map((r) => r[1]),
        [requests],
    );

    const columns = React.useMemo(
        () => [
            {
                Header: 'Kind',
                accessor: (row: JsiInterceptorRequest) => row.kind || '',
                disableSortBy: true,
                Cell: ({ cell: { value } }: { cell: { value: string } }) => (
                    <RequestJsiInterceptorKindTag value={value as RequestJsiInterceptorKind} />
                ),
                minWidth: '40px',
                width: '40px',
                maxWidth: '40px',
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
            {
                Header: 'Code',
                accessor: (row: JsiInterceptorRequest) => row.response?.status ?? '',
                disableSortBy: true,
                Cell: ({ cell: { value } }: { cell: { value: string } }) => <RequestStatusTag value={value} />,
                minWidth: '40px',
                width: '40px',
                maxWidth: '40px',
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
            {
                Header: 'Method',
                accessor: (row: JsiInterceptorRequest) => row.method || '',
                disableSortBy: true,
                Cell: ({ cell: { value } }: { cell: { value: string } }) => (
                    <RequestMethodTag value={value as RequestMethod} />
                ),
                minWidth: '40px',
                width: '40px',
                maxWidth: '40px',
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
            {
                Header: 'URL',
                accessor: (row: JsiInterceptorRequest) => row.url ?? '',
                Cell: ({ cell: { value } }: { cell: { value: string } }) => {
                    return (
                        <Box as="span" wordBreak="break-all" textAlign="left">
                            {value}
                        </Box>
                    );
                },
                disableSortBy: false,
                minWidth: 100,
                width: 300,
                maxWidth: 1000,
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
            {
                Header: 'Date',
                accessor: (row: JsiInterceptorRequest) => toISOString(row.time ?? ''),
                Cell: ({ cell: { value } }: { cell: { value: string } }) => {
                    return formatTimeHHmmssSSS(value);
                },
                minWidth: '80px',
                width: '80px',
                maxWidth: '80px',
                paddingInline: '5px',
                paddingBlock: '5px',
                headerPaddingInline: '5px',
                headerPaddingBlock: '5px',
            },
        ],
        [requests],
    ) as Array<Column<JsiInterceptorRequest>>;

    return (
        <>
            <TableContainer
                columns={columns}
                data={requestsArray}
                hiddenColumns={['state']}
                showColoredState={false}
                search={{
                    placeholder: 'Search for request',
                }}
                rowClick={(row) => setSelected(row)}
                searchBarStyles={{ paddingLeft: '10px' }}
                defaultPageSize={10}
            />
        </>
    );
});
